import React, { useEffect } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import { Permiso, Roles } from "../../constants/Roles";
import { useAuth } from "../../authentication";
import { FileSearchOutlined, UserOutlined, BarChartOutlined, FileProtectOutlined, TeamOutlined } from "@ant-design/icons";

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const { authUser } = useAuth();

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <UserProfile sidebarCollapsed={sidebarCollapsed} />
          {/* <AppsNavigation/> */}
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            <Menu.Item style={{display:"none"}} key="dashboard">
              <Link to="/dashboard">
                <span style={{ color: "#FFF",fontWeight:'800' }}>
                  <BarChartOutlined />
                  {!sidebarCollapsed && <IntlMessages id="Dashboard" />}
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item key="perfil">
              <Link to="/profile">
                <span style={{ color: "#FFF",fontWeight:'800' }}>
                  <UserOutlined />
                  {!sidebarCollapsed && <IntlMessages id="Perfil Cliente" />}
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item key="candidates">
              <Link to="/candidates">
                <span style={{ color: "#FFF",fontWeight:'800' }}>
                  <TeamOutlined />
                  {!sidebarCollapsed && <IntlMessages id="Candidatos" />}
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item key="result">
              <Link to="/results-exams">
                <span style={{ color: "#FFF",fontWeight:'800' }}>
                  <FileProtectOutlined />
                  {!sidebarCollapsed && <IntlMessages id="Procesos" />}
                </span>
              </Link>
            </Menu.Item>
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);

